import { Stack, StepContent } from "@mui/material";
import type { ApprovalStepState } from "../../../api/types/approvalTypes";
import ApprovalRuleContent from "./ApprovalRuleContent";

interface Props {
  step: ApprovalStepState;
  notStarted: boolean;
}

const ApprovalStepContent = ({ step, notStarted }: Props) => {
  if (step.status === "Skipped") {
    return <StepContent />;
  }

  return (
    <StepContent>
      <Stack spacing={2}>
        {step.rules.map((stepRule) => (
          <ApprovalRuleContent
            key={stepRule.ruleIndex}
            rule={stepRule}
            stepStatus={step.status}
            notStarted={notStarted}
          />
        ))}
      </Stack>
    </StepContent>
  );
};

export default ApprovalStepContent;
